module.exports = __webpack_public_path__ + "Contact Rocky Mountain Reserve Flyer.pdf";